import React from "react";
import "./index.scss";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import MailIcon from "@mui/icons-material/Mail";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import EpaymentPartner from "../epaymentpartner";
import Setting from "./setting";
import axios from "axios";
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import { LangContext } from "../../context/LangContext";
const Footer = () => {
  const lang = React.useContext(LangContext);
  const nep = lang.state.np;
  const [setting, setSetting] = React.useState();
  const APIURL = `${process.env.REACT_APP_URL}site_settings`;

  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setError(false);
        const response = await axios.get(APIURL);
        setSetting(response.data.site_settings);
        //console.log(response.data.site_settings);
        setLoading(false);
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    })();
  }, []);
  if (loading) return "..";
  if (error) return "";

  return (
    <>
      <div className="MainFooterContainer">
        <div className="wrapper">
          <div className="FooterItemBox">
            <Setting setting={setting} nep={nep} />
            <div className="FooterItem">
              <h4>{nep ? "महत्त्वपूर्ण लिङ्कहरू" : "Important Links"}</h4>
              <ul>
                <li>
                  <Link to={"rates/interest-rates"}>
                    {nep ? "ब्याज दरहरू" : "Interest Rates"}
                  </Link>
                </li>
                <li>
                  <Link to={"/rates/standard-tariff-of-charges"}>
                    {nep
                      ? "Standard Tariff of Charges"
                      : "Standard Tariff of Charges"}
                  </Link>
                </li>
                <li>
                  <Link to={"rates/fiscal-year-wise-interest"}>
                    {nep
                      ? "आर्थिक वर्ष अनुसार ब्याजदर"
                      : "Fiscal Year Wise Interest"}
                  </Link>
                </li>
                <li>
                  <Link to={"rates/base-rate"}>
                    {nep ? "आधार दर" : "Base Rate"}
                  </Link>
                </li>
                <li>
                  <Link to={"rates/interest-spread-rate"}>
                    {nep ? "ब्याज प्रसार दर" : "Interest Spread Rate"}
                  </Link>
                </li>
                <li>
                  <Link to={"forex-rates"}>
                    {nep ? "विदेशी मुद्रा दर" : "Forex Rates"}
                  </Link>
                </li>
                <li>
                  <Link to="https://fenegosida.org/" target="_blank">
                    {nep ? "सुन/चाँदीको मूल्य" : " Gold/Silver Prices"}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://nepalstock.com.np/company/detail/263"
                    target="_blank"
                  >
                    {nep ? "स्टक एक्सचेन्ज" : "Stock Exchange"}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="FooterItem">
              <h4>{nep ? "हाम्रो बारे" : "ABOUT US"}</h4>
              <ul>
                <li>
                  <Link to={"about/introduction"}>
                    {nep ? "परिचय" : "Introduction"}
                  </Link>
                </li>
                <li>
                  <Link to={"about/bod"}>
                    {nep ? "सञ्चालक समिति" : "Board of Directors"}
                  </Link>
                </li>
                <li>
                  <Link to={"about/management-team"}>
                    {nep ? "व्यवस्थापन समुह" : "Management Team"}
                  </Link>
                </li>
                <li>
                  <Link to={"about/head-of-department"}>
                    {nep ? "विभागिय प्रमुख" : "Head of Department"}
                  </Link>
                </li>
                <li>
                  <Link to={"about/province-head"}>
                    {nep ? "प्रदेश प्रमुख" : "Province Head"}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="FooterItem">
              <h4>{nep ? "उपयोगी लिंकहरु" : "QUICK LINKS"}</h4>
              <ul>
                <li>
                  <Link to={"contact-us"}>
                    {nep ? "हाम्रो सम्पर्क" : "Contact Us"}
                  </Link>
                </li>
                <li>
                  <Link to={"downloads"}>{nep ? "डाउनलोड" : "Downloads"}</Link>
                </li>
                <li>
                  <Link to={`news-&-events`}>
                    {nep ? "समाचार र घटनाहरू" : "News & Events"}
                  </Link>
                </li>
                <li>
                  <Link to={`network/branches`}>
                    {nep ? "हाम्रो नेटवर्क" : "Our Network"}
                  </Link>
                </li>
                <li>
                  <Link to={`faqs`}>{nep ? "प्रश्नोत्तर" : "FAQs"}</Link>
                </li>
              </ul>
            </div>
          </div>
          <EpaymentPartner nep={nep} />
        </div>
      </div>
      <div className="CopyRights">
        <div className="wrapper">
          <div className="CopyrightContent">
            <ul>
              <li>
                <Link to={setting.facebook} target="_blank">
                  <FacebookIcon fontSize="small" />
                </Link>
              </li>
              <li>
                <Link to={setting.instagram} target="_blank">
                  <InstagramIcon fontSize="small" />
                </Link>
              </li>
              <li>
                <Link to={setting.linked_in} target="_blank">
                  <LinkedInIcon fontSize="small" />
                </Link>
              </li>
              <li>
                <Link to={setting.twitter} target="_blank">
                  <TwitterIcon fontSize="small" />
                </Link>
              </li>
              <li>
                <Link to={setting.youtube} target="_blank">
                  <YouTubeIcon fontSize="small" />
                </Link>
              </li>
            </ul>
            <p>
              © {new Date().getFullYear()} | {setting.site_name} | All Right
              Reserved.
            </p>
          </div>
        </div>
      </div>
      <ScrollToTop smooth />
    </>
  );
};
export default Footer;
